export default __webpack_public_path__ + "static/media/pic106.060ad058.jpg";